import { ROLE_LABELS } from '@crm/shared'

// Подпись роли в шапке меню и в мобильной шапке (решение Сергея 26.09.2026):
// вместо кода роли («ROS», «ADMIN») — русская подпись из ROLE_LABELS.

/** Полная русская подпись роли; неизвестная роль возвращается как есть. */
export function roleFullLabel(role: string): string {
  return (ROLE_LABELS as Record<string, string | undefined>)[role] ?? role
}

/**
 * Короткая подпись для шапки: часть подписи до « · » — у РОП и РОЗ это «РОП» /
 * «РОЗ», у остальных ролей « · » нет, и подпись полная («Администратор»,
 * «Генеральный директор»…). Неизвестная роль возвращается как есть.
 */
export function roleCaption(role: string): string {
  return roleFullLabel(role).split(' · ')[0]
}
